import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'DASHBOARD',
    icon: 'HomeIcon',
    href: '/',
  },
  {
    label: 'TRADE',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://exchange.robinhoodswap.finance/#/swap',
      },
      {
        label: 'Liquidity',
        href: 'https://exchange.robinhoodswap.finance/#/add/ETH/0xa9264b9023D28A78fCF54fAc3CEc827CBbB6ceC0',
      },
    ],
  },
  {
    label: 'FARMS',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'POOLS',
    icon: 'PoolIcon',
    href: '/pools',
  },
  {
    label: 'ARCADE',
    icon: 'PoolIcon',
    href: '/moneywheel',
  },
  {
    label: 'CHARTS',
    icon: 'InfoIcon',
    initialOpenState: false,
    items: [
      {
        label: 'Dex Guru',
        href: 'https://dex.guru/token/0xD5779F2F9D7D239228e4e78bC78F50768661A081-bsc',
      },
      {
        label: 'Poo Coin',
        href: 'https://poocoin.app/tokens/0xD5779F2F9D7D239228e4e78bC78F50768661A081',
      },
      {
        label: 'Bogged Finance',
        href: 'https://charts.bogged.finance/?token=0xD5779F2F9D7D239228e4e78bC78F50768661A081',
      },
      {
        label: 'Dex Tools',
        href: 'https://www.dextools.io/app/pancakeswap/pair-explorer/0x5b9f811D38fc6C1017E0774C552235b33F564DEb',
      },
    ],
  },

  {
    label: 'MORE',
    icon: 'MoreIcon',
    items: [
      // {
      //   label: 'Github',
      //   href: '',
      // },
      {
        label: 'GitBook',
        href: 'https://robinhoodswapfinance.gitbook.io/',
      },
      // {
      //   label: 'Blog',
      //   href: '',
      // },
    ],
  },

  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: '/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: '/nft',
  // },
  // {
  //   label: 'INFO',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'PancakeSwap',
  //       href: '',
  //     },
  // {
  //   label: 'CoinGecko',
  //   href: '',
  // },
  // {
  //   label: 'CoinMarketCap',
  //   href: '',
  // },
  // {
  //   label: 'AstroTools',
  //   href: '',
  //     // },
  //   ],
  // },

  {
    label: 'HOW TO',
    icon: 'MoreIcon',
    items: [
      {
        label: 'GET RBH',
        href: 'https://robinhoodswap.gitbook.io/robinhoodswap/how-to-guides/getting-rbh',
      },
      {
        label: 'Add Liquidity',
        href: 'https://robinhoodswap.gitbook.io/robinhoodswap/how-to-guides/getting-lps',
      },
      {
        label: 'How to Farm ',
        href: 'https://robinhoodswap.gitbook.io/robinhoodswap/how-to-guides/how-to-farm',
      },
    ],
  },
  // {
  //   label: 'Partnerships/IFO',
  //   icon: 'GooseIcon',
  //   href: 'https://docs.google.com/forms/d/e/1FAIpQLSe7ycrw8Dq4C5Vjc9WNlRtTxEhFDB1Ny6jlAByZ2Y6qBo7SKg/viewform?usp=sf_link',
  // },
  // {
  //   label: 'Audit by Hacken',
  //   icon: 'AuditIcon',
  //   href: 'https://www.goosedefi.com/files/hackenAudit.pdf',
  // },
  // {
  //   label: 'Audit by CertiK',
  //   icon: 'AuditIcon',
  //   href: 'https://certik.org/projects/goose-finance',
  // },
]

export default config
